export const LOGOUT_USER = 'LOGOUT_USER'
export const LOGIN_USER = 'LOGIN_USER'

export const UPDATE_GDPR = 'UPDATE_GDPR'

export const NOTIFICATION_DISPATCH = 'NOTIFICATION_DISPATCH'
export const NOTIFICATION_CLOSE = 'NOTIFICATION_CLOSE'

export const GET_STATES = 'GET_STATES'
export const SET_EMPLOYEE = 'SET_EMPLOYEE'
export const SET_USER = 'SET_USER'

export const SET_LANGUAGES = 'SET_LANGUAGES'

export const SET_PAYMENT_PLANS = 'SET_PAYMENT_PLANS'
